var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view page", attrs: { "data-app": "" } },
    [
      _vm.backButton
        ? _c("management-page-back-arrow", {
            on: {
              buttonClick: function($event) {
                return _vm.$router.back()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.customNavigation
        ? _c("management-page-back-arrow", {
            on: {
              buttonClick: function($event) {
                return _vm.$router.push({
                  name: _vm.pageName,
                  params: { uuid: _vm.uuid }
                })
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "v-layout",
            {
              staticClass: "title-section",
              attrs: {
                row: "",
                "justify-space-between": "",
                "align-start": "",
                wrap: ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", md5: "", lg3: "" } },
                [
                  _c(
                    "v-layout",
                    { staticClass: "page-header", attrs: { column: "" } },
                    [
                      _c("span", { staticClass: "page-title" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.title) + "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _vm._t("buttons"),
                          _vm._v(" "),
                          _vm.editButton
                            ? _c("view-page-button", {
                                attrs: {
                                  label: _vm.$t("Edit"),
                                  icon: "edit",
                                  disabled: _vm.editDisabled
                                },
                                on: { click: _vm.editItem }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.deleteButton
                            ? _c("view-page-button", {
                                attrs: {
                                  label: _vm.$t("Delete"),
                                  icon: "delete",
                                  disabled: _vm.deleteDisabled
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleDeleteDialog(true)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "page-section",
                      staticStyle: { padding: "0" }
                    },
                    [
                      _vm.hasImage
                        ? _c("img", {
                            staticClass: "data-image",
                            attrs: { src: _vm.image, alt: "Image icon" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "data-fields",
                          staticStyle: { padding: "40px" }
                        },
                        [_vm._t("leftSide")],
                        2
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", md6: "", lg8: "" } },
                [
                  _c(
                    "div",
                    { staticClass: "page-header" },
                    [_vm._t("headerRightSide")],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("rightSide")
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteButton
        ? _c("app-dialog-box", {
            attrs: {
              open: _vm.dialog,
              title: _vm.deleteDialogTitle,
              content: _vm.deleteDialogContent,
              "main-action-label": _vm.$t("No"),
              "secondary-action-label": _vm.$t("Yes")
            },
            on: {
              mainAction: function($event) {
                return _vm.toggleDeleteDialog(false)
              },
              secondaryAction: _vm.deleteItem
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        attrs: { active: _vm.loading, "is-full-page": false, color: "accent" },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4d780da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4d780da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/ViewPage/ViewPage.vue
// module id = null
// module chunks = 